const { setDataKeyPrefix, setRetrievalFunction } = require('@swa-ui/bootstrap');
const { window } = require('@swa-ui/browser/window');

setRetrievalFunction(window.require);
setDataKeyPrefix('swa-bootstrap-corporate-landing-home-page/');
